
<template>
  <div class="GroupBulkShelvesContent">
    <BulkShelvesContent
      ref="BulkShelvesContentRef"
      :smallShopItem="true"
      :openEdit="openEditDialog"
      :closeEdit="closeEditDialog"
      @iframeClose="iframeClose"
    ></BulkShelvesContent>
    <EditDialog ref="editDialog" />
    <BulkShelvesResults
      ref="bulkShelvesResults"
      :publishSpeedResult="publishResult"
      :percentage="publishPercenttage"
      :pageId="pageId"
    />
  </div>
</template>

<script>
import BulkShelvesContent from '@components/prod/center/BasicComps/BulkShelvesContent';
import BulkShelvesResults from "@/components/prod/center/dialogs/bulkShelvesResults.vue";
import EditDialog from '@/components/prod/center/dialogs/EditDialog.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    BulkShelvesContent,
    EditDialog,
    BulkShelvesResults
  },
  
  data() {
      return {
          pageId: 'd_goods',
          mockEventData: {},
          ids:[]
    };
    },
  mounted() {
      window.addEventListener('message', this.receiveMessage, false);
      this.$nextTick(() => {
            window.parent.postMessage({ data: { isMounted: true }, eventName: 'mounted' },'*'); 
       });
  },
  computed: {
    ...mapGetters([
      "speedResult",
      "speedPercentage",
      "speedResultVisible",
    ]),
    publishResult() {
      return this.speedResult(this.pageId);
    },
    publishPercenttage() {
      return this.speedPercentage(this.pageId);
    },
    bulkShelvesResultsVisible() {
      return this.speedResultVisible(this.pageId)
    },
  },
  watch: {
    bulkShelvesResultsVisible(v) {
      // window.parent.postMessage({ data: { speedResultVisible: v  }, eventName: 'speedResultVisible' }, '*');
    }
  },

  methods: {
    receiveMessage (event) {
      const { data = {}, eventName } = event.data;
      if (eventName == 'open') {
        let { type, list=[] } = data.publishParams || {};
        let rows = list, configs = {};
        configs = {
            publishType: 'PUBLISH_ITEM',
            publishEntrance: 0
        };
        this.$refs.BulkShelvesContentRef.method_open(type, rows, configs);
      } else if ('closeDialog') {
      }
    },
    openEditDialog(params, extraParams) {
      this.$refs.editDialog.method_open(params, extraParams);
    },
    closeEditDialog() {
      this.$refs.editDialog.method_close();
    },
    iframeClose(visible) {
      console.log('iframeClose', visible);
        if (!visible) {
            window.parent.postMessage({ data: {  }, eventName: 'modalClose' }, '*');
            return;
        }
    },
  },
};
</script>

<style lang='scss' scoped>
    .GroupBulkShelvesContent{
        width: 800px;
        margin: 20px auto;
    }
</style>
